import React, { useState } from 'react'
import { gql, useMutation, useApolloClient } from '@apollo/client'
import MassMessageModal from '../../../Material/MassMessageModal'
import StripeModal from '../../../Stripe/StripeModal'
import { toGlobalId } from './helpers'

const CHANGE_TRACKER_STATUS = gql`
    mutation ChangeTrackerStatus($input: TrackerStatusChangeMutationInput!) {
        changeTrackerStatus(input: $input) {
            ok
            errors {
                field
                messages
            }
            car {
                id
                pk
                trackerStatus
            }
        }
    }
`

export default function RowActions({
    collectionCase: c,
    onOpenPencil,
    expanded,
    isActiveSidebarDriver,
    onSelectDriverForSidebar,
    onToggleExpand,
}) {
    const [openModal, setOpenModal] = useState(null) // 'message' | 'charge' | null
    const apolloClient = useApolloClient()
    const [changeTracker, { loading: trackerLoading }] = useMutation(CHANGE_TRACKER_STATUS, {
        refetchQueries: ['AllCollectionCases'],
    })

    const driverGid = toGlobalId('DriverNode', c.driverId)
    const carGid = c.driverActiveCarId ? toGlobalId('CarNode', c.driverActiveCarId) : null
    const hasCar = !!c.driverActiveCarId
    const carDisabled = !!c.driverActiveCarIsDisabled

    const stop = (e) => e.stopPropagation()

    const fireTracker = (command) => (e) => {
        stop(e)
        if (!carGid || trackerLoading) return
        const verb = command.toLowerCase()
        const confirmed = window.confirm(
            `${verb[0].toUpperCase() + verb.slice(1)} ${c.driverName || 'this driver'}'s car?`,
        )
        if (!confirmed) return
        changeTracker({
            variables: {
                input: {
                    carId: carGid,
                    command,
                },
            },
        })
    }

    return (
        <div className="cd-rowactions" onClick={stop}>
            <button
                type="button"
                className="cd-rowaction always-visible"
                onClick={(e) => {
                    stop(e)
                    if (onToggleExpand) onToggleExpand()
                }}
                title={expanded ? 'Collapse' : 'Expand'}
                aria-label={expanded ? 'Collapse details' : 'Expand details'}
                aria-expanded={!!expanded}
            >
                <i className={`fa fa-chevron-${expanded ? 'up' : 'down'}`} />
            </button>
            <button
                type="button"
                className="cd-rowaction"
                onClick={(e) => {
                    stop(e)
                    onOpenPencil()
                }}
                title="Add activity / note"
                aria-label="Add activity note"
            >
                <i className="fa fa-pencil" />
            </button>
            <button
                type="button"
                className="cd-rowaction"
                onClick={(e) => {
                    stop(e)
                    setOpenModal('message')
                }}
                title="Send message"
                aria-label="Send message"
            >
                <i className="fa fa-comment" />
            </button>
            <button
                type="button"
                className="cd-rowaction"
                onClick={(e) => {
                    stop(e)
                    setOpenModal('charge')
                }}
                title="Charge driver"
                aria-label="Charge driver"
            >
                <i className="fa fa-credit-card" />
            </button>

            {hasCar && !carDisabled && (
                <button
                    type="button"
                    className="cd-rowaction danger"
                    onClick={fireTracker('DISABLE')}
                    disabled={trackerLoading}
                    title="Disable car"
                    aria-label="Disable car"
                >
                    <i className="fa fa-ban" />
                </button>
            )}
            {hasCar && carDisabled && (
                <>
                    <button
                        type="button"
                        className="cd-rowaction success"
                        onClick={fireTracker('ENABLE')}
                        disabled={trackerLoading}
                        title="Enable car"
                        aria-label="Enable car"
                    >
                        <i className="fa fa-check" />
                    </button>
                    <button
                        type="button"
                        className="cd-rowaction danger"
                        onClick={fireTracker('REPO')}
                        disabled={trackerLoading}
                        title="Send to repo"
                        aria-label="Send to repo"
                    >
                        <i className="fa fa-flag" />
                    </button>
                </>
            )}

            {openModal === 'message' && driverGid && (
                <MassMessageModal
                    open
                    handleClose={() => setOpenModal(null)}
                    drivers={[driverGid]}
                    apolloClient={apolloClient}
                />
            )}
            {openModal === 'charge' && driverGid && (
                <StripeModal
                    isOpen
                    handleClose={() => setOpenModal(null)}
                    driverId={driverGid}
                />
            )}
        </div>
    )
}
